import React from 'react';
import {
  HeaderWrapper, LogoImage,
} from './StyledComponents';

export default () => (
  <HeaderWrapper>
    <LogoImage />
  </HeaderWrapper>
);
